export const META_START = "META_START";
export const META_FAIL = "META_FAIL";
export const GET_META = "GET_META";
export const GET_META_SUCCESS = "GET_META_SUCCESS";
export const CREATE_META = "CREATE_META";
export const UPDATE_META = "UPDATE_META";
export const CREATE_META_SUCCESS = "CREATE_META_SUCCESS";
export const UPDATE_META_SUCCESS = "UPDATE_META_SUCCESS";
